module.exports = __webpack_public_path__ + "img/word.b9a01e98.jpg";